module.exports = __webpack_public_path__ + "static/media/heringsLOGO_black.5e815145.svg";